import { HTMLInputTypeAttribute } from "react";
import { Controller, FieldValues, RegisterOptions } from "react-hook-form";

interface Props {
  label?: string;
  type?: HTMLInputTypeAttribute | undefined;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
  control?: any;
  name?: string;
  disabled?: boolean;
  rules?:
    | Omit<
        RegisterOptions<FieldValues, string>,
        "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
      >
    | undefined;
}

export const ControlledInput = ({
  label,
  type,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  control,
  name,
  rules,
  disabled,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <Controller
        control={control}
        name={name as string}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <input
            {...rest}
            disabled={disabled}
            value={value}
            onChange={onChange}
            type={type}
            className={`w-full h-[46px] px-4 bg-sky-lighter border ${
              error ? "border-red-base" : "border-gray-border"
            } ${
              error ? "focus:border-red-base" : "focus:border-focused-border"
            } rounded font-satoshi text-base text-dark font-medium outline-none disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed ${inputClassName}`}
            placeholder={placeholder}
          />
        )}
      />
    </div>
  );
};
